import clsx from "clsx";

export interface ButtonRoundProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  label: string;
}

export function ButtonRound({
  className,
  label,
  disabled = false,
  ...props
}: ButtonRoundProps): React.ReactNode {
  return (
    <button
      className={clsx(
        "[border:none] py-2.5 px-5 bg-[#fac83c] rounded-full flex flex-row items-center justify-center",
        className,
        {
          "opacity-50 cursor-not-allowed": disabled,
          "cursor-pointer": !disabled,
        }
      )}
      type="button"
      disabled={disabled}
      {...props}
    >
      <b className="relative text-[16px] leading-[24px] text-[#5a5a5a] text-center">{label}</b>
    </button>
  );
}
